import { Trans } from "react-i18next";

import { Flex, Image } from "@chakra-ui/react";

import { Text } from "@components/Text";

interface PropTypes {
    coverImage: string;
    category: string;
    title: string;
}

const ArticleItem = ({ coverImage, category, title }: PropTypes) => {
    return (
        <Flex
            direction="column"
            borderRadius={20}
            border="1px solid"
            borderColor="gray.300"
            w={["full", 300, null, null, 357]}
            cursor="pointer"
            bg="white"
            overflow="hidden"
        >
            <Image
                w="full"
                h={[150, null, null, 200]}
                objectFit="cover"
                src={coverImage}
                data-testid="item-image"
            />
            <Flex
                direction="column"
                gap={[1, null, null, 2]}
                p={[3, null, null, 5]}
            >
                <Text fontSize={12}>{category}</Text>
                <Text type="subHeading" lineHeight="25px">
                    {title}
                </Text>
                <Text>
                    <Trans>Read more</Trans>
                </Text>
            </Flex>
        </Flex>
    );
};

export default ArticleItem;
